declare var jQuery;
declare var Chart;
namespace TotalPoll {


    export class LiveResults {
        public data: any = {};
        public settings: any = {
            data: [],
            type: 'doughnut',
            options: {
                legendCallback: function (chart) {
                    var text = [];
                    text.push('<div class="live-results-items">');
                    text.push(`<h3 class="live-results-title">${chart.data.title}</h3>`);
                    for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
                        text.push('<div class="live-results-item">');
                        text.push(`<div class="live-results-item-text">${chart.data.labels[i]}</div>`);
                        text.push(`<div class="live-results-item-percentage"><div class="live-results-item-percentage-text" style="background-color:${chart.data.datasets[0].backgroundColor[i]};"><span>${chart.data.datasets[0].text[i]}</span></div><div class="live-results-item-percentage-bar" style="background-color:${chart.data.datasets[0].backgroundColor[i]}; width: ${chart.data.datasets[0].text[i]};">&nbsp;</div></div>`);
                        text.push('</div>');
                    }
                    text.push('</div>');
                    return text.join("");
                },
                legend: {
                    display: false,
                    position: 'right',
                    labels: {
                        fontSize: 28,
                        fontStyle: 'bold',
                        boxWidth: 50,
                        padding: 30
                    },
                },
                animation: {
                    duration: '1000',
                    easing: 'easeOutQuart',
                    animateScale: true,
                    animateRotate: true
                },
                title: {
                    display: false,
                }
            }
        };
        public url;
        private $legend;
        private canvasTemplate = `<canvas class="totalpoll-live-polling-chart" width="400" height="300"></canvas>`;
        private charts: any = {};

        constructor(public $poll) {
            this.parseUrl();
            this.parseChartParams();
            this.parseData();
            this.prepareCharts();
            setInterval(this.refresh.bind(this), 3000);
        }

        fetchData() {
            return jQuery.get(this.url)
                .then((response) => response.data.questions);
        }

        getColors() {
            return ['#f94144', '#f3722c', '#f8961e', '#f9c74f', '#90be6d', '#43aa8b', '#577590', '#067bc2', '#84bcda', '#000000',]
                .sort(function () {
                    return 0.5 - Math.random()
                });
        }

        parseData() {
            this.updateData(
                this.transformDataToChartData(JSON.parse(this.$poll.attr('totalpoll-live-polling-data')))
            );
        }

        parseUrl() {
            this.url = this.$poll.attr('totalpoll-live-polling-url');
        }

        parseChartParams() {
            this.settings.type = this.$poll.attr('totalpoll-live-polling-chart-type') || 'doughnut';
            this.settings.options.legend.visible = Boolean(this.$poll.attr('totalpoll-live-polling-chart-legend'));
            if ((this.settings.type === 'doughnut' || this.settings.type === 'pie') && !this.settings.options.legend.visible) {
                this.settings.options.legend.display = true;
            }
        }

        prepareCharts() {
            for (let questionUid in this.data) {
                let chart = {
                    dom: jQuery(this.canvasTemplate).appendTo(this.$poll).get(0),
                    settings: jQuery.extend(
                        true,
                        {},
                        this.settings,
                        {
                            data: this.data[questionUid],
                            options: {
                                title: {
                                    text: this.data[questionUid].title
                                }
                            }
                        },
                    ),
                    instance: null
                };
                chart.instance = new Chart(chart.dom, chart.settings);

                this.charts[questionUid] = chart;
                if (this.settings.options.legend.visible) {
                    this.$legend = jQuery('<div></div>').appendTo(this.$poll).html(chart.instance.generateLegend());
                }
            }
        }

        refresh() {
            this.fetchData()
                .then(this.transformDataToChartData.bind(this))
                .then(this.updateData.bind(this))
                .then(this.updateCharts.bind(this))
        }

        transformDataToChartData(data?) {
            let colors = this.getColors();
            let dataset = {};
            for (let questionUid in data) {
                dataset[questionUid] = {title: data[questionUid]['content'], labels: [], datasets: [{data: [], text: [], backgroundColor: []}]};
                for (let choiceUid in data[questionUid]['choices']) {
                    if (colors.length == 0) {
                        colors = this.getColors();
                    }
                    dataset[questionUid]['labels'].push(`${data[questionUid]['choices'][choiceUid].label}`);
                    dataset[questionUid]['datasets'][0]['data'].push(data[questionUid]['choices'][choiceUid].votes);
                    dataset[questionUid]['datasets'][0]['text'].push(data[questionUid]['choices'][choiceUid].votesFormatted);
                    dataset[questionUid]['datasets'][0]['backgroundColor'].push(data[questionUid]['choices'][choiceUid].color || colors.pop());
                }
            }

            return dataset;
        }

        transformDataToChartDatasets(data?) {
            let colors = this.getColors();
            let dataset = {};
            for (let questionUid in data) {
                dataset[questionUid] = {title: data[questionUid]['content'], labels: ['Choices'], datasets: []};
                let index = 0;
                for (let choiceUid in data[questionUid]['choices']) {
                    dataset[questionUid]['datasets'][index] = {data: [data[questionUid]['choices'][choiceUid].votes], label: data[questionUid]['choices'][choiceUid].label, backgroundColor: data[questionUid]['choices'][choiceUid].color || colors.pop()};
                    index++;
                }
            }

            return dataset;
        }

        updateCharts() {
            for (let questionUid in this.charts) {
                let chart = this.charts[questionUid].instance;

                this.data[questionUid].datasets[0].data.forEach((val, index) => {
                    chart.data.datasets[0].data[index] = val;
                    chart.data.datasets[0].text[index] = this.data[questionUid].datasets[0].text[index];
                });

                this.data[questionUid].labels.forEach((label, index) => {
                    chart.data.labels[index] = label;
                });

                chart.update(1000);

                if (this.$legend) {
                    this.$legend.html(chart.generateLegend());
                }
            }
        }

        updateData(data) {
            this.data = data;
        }
    }

    jQuery(($) => {

        $('.totalpoll-live-polling').each(function () {
            let $poll = $(this);
            $poll.data('live-polling', new LiveResults($poll));
        });

    });
}
